import $ from 'jquery';

$(document).ready(function () {
    const bgHeader = document.getElementById('bgHeader');
    if(bgHeader) {
        bgHeader.children[0].style.display = "block";

        if (bgHeader.children.length <= 1) return;

        const bgSlideshowTimer = document.getElementById('bannerSlideshowTimer');

        let timer = 5000;
        try {
            if (parseInt(bgSlideshowTimer.innerHTML))
                timer = parseInt(bgSlideshowTimer.innerHTML) * 1000;
        } catch (err) {
            timer = 5000;
        }

        const myTimeout = setTimeout(slidShow, timer);

        function slidShow() {
            let nextIndexToDisplay = 0;
            for (let i = 0; i < bgHeader.children.length; i++) {
                if (bgHeader.children[i].style.display == 'block') {
                    nextIndexToDisplay = i + 1;
                }

                bgHeader.children[i].style.display = "none";
            }

            if (nextIndexToDisplay == bgHeader.children.length) {
                nextIndexToDisplay = 0;
            }

            bgHeader.children[nextIndexToDisplay].style.display = "block";
            setTimeout(slidShow, timer);
        }
    }
});